export default function TourPage() {
  return (
    <div style={{ margin: 0, padding: 0, background: '#000', width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <video
        src="https://assets.coachsightecr.com/tour.mp4"
        controls
        playsInline
        style={{ display: 'block', width: '100%', height: '100%', objectFit: 'contain' }}
      />
    </div>
  );
}
